import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { isEscapeKey } from '../../../domain/utils/isEscapeKey';
import { IconClose } from '../../Icon/IconClose';
import { Actionable } from '../atoms/Actionable';
import { t } from '../../../domain/services/configService/configService';
import { theme } from '../../../domain/theme';

export const ClosableBox = ({
  closeColor,
  closeText,
  closeCb,
  closeIconPosition,
  styles: customStyles,
  children
}) => {
  const handleEscape = e => isEscapeKey(e) && closeCb();

  useEffect(() => {
    document.addEventListener('keydown', handleEscape);
    return () => {
      closeCb();
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  const styles = {
    defaultBox: css`
      position: relative;
    `,

    close: css`
      position: fixed;
      top: ${Object.prototype.hasOwnProperty.call(closeIconPosition, 'top')
        ? closeIconPosition.top
        : 30}px;
      right: ${Object.prototype.hasOwnProperty.call(closeIconPosition, 'right')
        ? closeIconPosition.right
        : 30}px;
      cursor: pointer;
      outline: none;
      float: right;
      /* Use a default z-index just in case our children use also z-index */
      z-index: 10;
      span {
        ${theme.font.family('boldWeb')};
        letter-spacing: 3px;
        line-height: 3.5;
        text-transform: uppercase;
        font-size: ${theme.font.size('xs')};
        color: #fff;
        margin-right: ${theme.spacing('xs')};
      }
      svg {
        vertical-align: middle;
      }
    `,

    buttonReset: css`
      margin: 0;
      padding: 0;
      border: 0;
      outline: 0;
      background: transparent;
    `
  };

  return (
    <div
      css={css`
        ${styles.defaultBox};
        ${customStyles};
      `}
    >
      <div css={styles.close}>
        <Actionable onClick={closeCb} title={t('Close')}>
          {closeText && <span>{closeText}</span>}
          <IconClose color={closeColor} />
        </Actionable>
      </div>
      {children}
    </div>
  );
};

ClosableBox.defaultProps = {
  closeColor: 'white',
  closeText: undefined,
  closeIconPosition: {},
  styles: undefined
};

ClosableBox.propTypes = {
  closeColor: PropTypes.string,
  closeText: PropTypes.string,
  closeCb: PropTypes.func.isRequired,
  closeIconPosition: PropTypes.shape({
    top: PropTypes.number,
    right: PropTypes.number
  }),
  styles: PropTypes.objectOf(PropTypes.any),
  children: PropTypes.node.isRequired
};
